import { useCallback, useEffect, useRef, useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { useReactToPrint } from "react-to-print";
import { Button, Flex, Text } from "@paguelofacil/pf-components";

import LogoCryptoFacil from "../assets/images/logo-cryptofacil.png";
import { language, languageDefault } from "../services/utils/Language";
import { TransactionInformation } from "../components/Receive/TransactionInformation";
import AppWithErrorBoundary from "../components/Error/ErrorBoudary";

import "../assets/scss/receive.scss";

const Receive = ({ intl }) => {
    const onBeforeGetContentResolve = useRef(null);
    const componentRefPrint = useRef(null);
    const [isLoadingButtonDownload, setIsLoadingButtonDownload] = useState(false);

    const handleOnBeforeGetContent = useCallback(() => {
        console.log("`onBeforeGetContent` called"); // tslint:disable-line no-console
        setIsLoadingButtonDownload(true);

        return new Promise(resolve => {
            onBeforeGetContentResolve.current = resolve;

            setTimeout(() => {
                setIsLoadingButtonDownload(false);
                resolve(null);
            }, 2000);
        });
    }, [setIsLoadingButtonDownload]);

    const reactToPrintContent = useCallback(() => {
        return componentRefPrint.current;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [componentRefPrint.current]);

    const handlePrint = useReactToPrint({
        content: reactToPrintContent,
        documentTitle: intl.formatMessage({
            id: language.proof_recharge,
            defaultMessage: languageDefault.proof_recharge,
        }),
        onBeforeGetContent: handleOnBeforeGetContent,
        removeAfterPrint: true,
    });

    useEffect(() => {
        if (!isLoadingButtonDownload && typeof onBeforeGetContentResolve.current === "function") {
            onBeforeGetContentResolve.current();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onBeforeGetContentResolve.current, isLoadingButtonDownload]);

    return (
        <AppWithErrorBoundary>
            <Flex direction="column" justify="center" align="center" bg="transparent" gap="1.5rem">
                <div ref={componentRefPrint} className="container-receive">
                    <Flex direction="column" minW="auto" width="auto" className="container-inter-receive" gap="1.5rem">
                        <Flex gap="0.5rem">
                            <img src={LogoCryptoFacil} className="img-header" alt="logo cryptofacil" />
                        </Flex>
                        <Text variant="body3" className="title-receive">
                            <FormattedMessage
                                id={language.title_receive}
                                defaultMessage={languageDefault.title_receive}
                            />
                        </Text>
                        <Text variant="body6" color="#3D444F" weight="regular" className="subtitle-receive">
                            <FormattedMessage
                                id={language.subtitle_receive}
                                defaultMessage={languageDefault.subtitle_receive}
                            />
                        </Text>

                        <TransactionInformation />
                    </Flex>
                </div>
                <div className="container-receive-transparent">
                    <Button
                        style={{ backgroundColor: "#378FA2", color: "#fff" }}
                        widthAuto
                        size="md"
                        handleClick={handlePrint}
                        disabled={isLoadingButtonDownload}
                    >
                        <FormattedMessage
                            id={language.download_receipt}
                            defaultMessage={languageDefault.download_receipt}
                        />
                    </Button>
                </div>
            </Flex>
        </AppWithErrorBoundary>
    );
};

const ReceiveDecorate = injectIntl(Receive);

export default ReceiveDecorate;
